import { useParams } from 'react-router-dom'

import { ResidentAppError } from '../../../common/error'

export const useCurrentDefectNotice = () => {
  const { defectNoticeUuid } = useParams()

  if (!defectNoticeUuid) {
    throw ResidentAppError.ClientError('NOT_FOUND', {
      message: 'No defectNoticeUuid found in params',
    })
  }

  return {
    currentDefectNoticeUuid: defectNoticeUuid,
  }
}
